import { render, staticRenderFns } from "./body.vue?vue&type=template&id=299af2fe"
import script from "./body.vue?vue&type=script&lang=js"
export * from "./body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports